import { Button } from "antd";
import { UnorderedListOutlined } from "@ant-design/icons";

const ShowColumn = ({
  id = "btn-show-column",
  icon = <UnorderedListOutlined />,
  onClick = () => {},
  ...props
}) => {
  return <Button id={id} icon={icon} onClick={onClick} {...props} />;
};

export default ShowColumn;
